/* eslint-disable jam3/no-sanitizer-with-danger */

import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'

// We can inject some CSS into the DOM.
const styles = theme => ({
  root: {
    borderBottom: '1px solid #ccc',
    padding: `${theme.spacing(4)} 0`,
  },
  LeftLabel: {
    color: theme.colors.darkGrey,
    fontSize: theme.typography.fontSizeSm,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontFamily: theme.typography.defaultFont,
  },
  rightLabel: {
    display: 'flex',
    justifyContent: 'flex-end',
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    fontSize: theme.typography.fontSizeLg,
  },
})

function Label(props) {
  const { label, value, color, classes, currencySign, ...rest } = props
  const currencyIcon = !currencySign ? '' : currencySign
  return (
    <Grid container className={classes.root} {...rest}>
      <Grid item xs={7} className={classes.LeftLabel}>
        {label}
      </Grid>
      {!currencyIcon && !currencyIcon === '' ? (
        <Grid
          item
          xs={5}
          className={classes.rightLabel}
          style={color ? { color: `${color}` } : null}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: TODO
          dangerouslySetInnerHTML={{ __html: value }}
        />
      ) : (
        <Grid item xs={5} className={classes.rightLabel} style={color ? { color: `${color}` } : null}>
          {`${currencyIcon}${value}`}
        </Grid>
      )}
    </Grid>
  )
}

Label.defaultProps = {
  color: '#009ADE',
}

export default withStyles(styles)(Label)
